/* eslint-disable */
// @ts-nocheck
import { createLucideIcon } from 'lucide-react';

// Define the icon nodes
const iconNodes = [
  ["path", {"d":"M3.997 13.899A6.999 6.999 0 1 1 15.707 7h1.79a4.5 4.5 0 0 1 2.5 8.242M16 13.5H8m8 0L13.333 16M16 13.5 13.333 11M8 19.5h8m-8 0 2.666-2.5M8 19.5l2.666 2.5","strokeWidth":"1.5","key":"463f6m"}]
];

// Create and export the icon component
export const HybridCloudIcon = createLucideIcon("hybrid-cloud", iconNodes);
